import { getTokenFromLS } from "@dexteel/mesf-core";
import type { ReportPdfRequest } from "@/shared/models/ReportPdf";

const apiUrl = (path: string) =>
	new URL(
		path,
		document.getElementsByTagName("base")[0]?.href ??
			`${window.location.origin}/`,
	);

const readPdf = async (response: Response): Promise<Blob> => {
	if (!response.ok) {
		const error = await response.json().catch(() => null);
		throw new Error(
			error?.message ?? `Error generating the PDF (${response.status})`,
		);
	}
	return response.blob();
};

/**
 * Draws the report the page sends (`api/report-pdf`). It goes through fetch rather than a
 * link because the session token travels in a header.
 */
export const getReportPdf = async (report: ReportPdfRequest): Promise<Blob> =>
	readPdf(
		await fetch(apiUrl("api/report-pdf"), {
			method: "POST",
			headers: {
				Authorization: `Bearer ${getTokenFromLS()}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify(report),
		}),
	);

/** A PDF the API draws on its own from a procedure, with the query string given. */
export const getApiPdf = async (
	path: string,
	params: Record<string, string>,
): Promise<Blob> => {
	const url = apiUrl(path);
	for (const [name, value] of Object.entries(params))
		url.searchParams.set(name, value);
	return readPdf(
		await fetch(url, {
			headers: { Authorization: `Bearer ${getTokenFromLS()}` },
		}),
	);
};
